<!--赖传峰-->
<!--2022/4/1-->
<template>
  <ElButton
    class="pp-primary-button"
    :style="{ color: '#fff', height: height, '--el-button-hover-bg-color': '#5286FF' }"
    color="#306eff"
  >
    <template #loading>
      <span
        :style="style"
        class="pp-spin"
      >
        <svg
          fill="none"
          height="42"
          viewBox="0 0 42 42"
          width="42"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            :stroke="`url(#${id1})`"
            d="M21 11.375C15.6843 11.375 11.375 15.6843 11.375 21"
            stroke-linecap="round"
            stroke-width="3"
          />
          <path
            :stroke="`url(#${id2})`"
            d="M21 30.625C26.3157 30.625 30.625 26.3157 30.625 21"
            stroke-linecap="round"
            stroke-width="3"
          />
          <defs>
            <linearGradient
              :id="id1"
              gradientUnits="userSpaceOnUse"
              x1="16.1875"
              x2="10"
              y1="6.5625"
              y2="22"
            >
              <stop stop-color="currentColor" />
              <stop
                offset="1"
                stop-color="currentColor"
                stop-opacity="0.01"
              />
            </linearGradient>
            <linearGradient
              :id="id2"
              gradientUnits="userSpaceOnUse"
              x1="28.5"
              x2="20"
              y1="18"
              y2="32.5"
            >
              <stop
                stop-color="currentColor"
                stop-opacity="0.01"
              />
              <stop
                offset="1"
                stop-color="currentColor"
              />
            </linearGradient>
          </defs>
        </svg>
      </span>
    </template>
    <slot />
  </ElButton>
</template>
<script lang="ts" setup>
import { type CSSProperties } from 'vue'
import { computed } from '#imports'
import { useLayout } from '@/store/layout'

const props = defineProps<{ height?: CSSProperties['height'] }>()

const height = computed(() => props.height || (useLayout().isMobile ? '48px' : '36px'))
const style = computed(() => ({ height: props.height }))

const id1 = `pp-button-hash1-${Date.now()}`
const id2 = `pp-button-hash2-${Date.now()}`
</script>
